import { consumeLoading } from "@/lib/consume/loading"
import { consumeRouter } from "@/lib/consume/router"
import { ServicesContainerComponent } from "@/lib/services/container/component"

export const ServicesContainerConsumer = consumeLoading(
  consumeRouter(ServicesContainerComponent)
)
